export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteFooter.vue?vue&type=template&id=655dde72&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteFooter.vue?vue&type=template&id=655dde72&scoped=true&
// module id = 156
// module chunks = 0